import React, { useEffect, useState } from 'react';
import { Alert, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CompetentProfessionalListRow from './CompetentProfessionalListRow';
const CompetentProfessionalList = _ref => {
  let {
    companyId,
    setData,
    data,
    selectedProjectId,
    emptyList,
    removeEmptyRow,
    tableHeadings,
    showFileColumns,
    searchQuery,
    forNewProjectCreation = false,
    addCompetentProfessionalToNewProject,
    updateNewProjectCompetentProfessionals,
    removeNewProjectCompetentProfessional
  } = _ref;
  const {
    t
  } = useTranslation();
  const [duplicates, setDuplicates] = useState([]);
  useEffect(() => {
    const emails = data.map(a => a.email);
    const count = emails => emails.reduce((result, value) => ({
      ...result,
      [value]: (result[value] || 0) + 1
    }), {}); // don't forget to initialize the accumulator
    const duplicates = dict => Object.keys(dict).filter(a => dict[a] > 1);
    setDuplicates(duplicates(count(emails)).filter(e => e !== '').filter(e => e !== null).filter(e => e !== undefined).filter(e => e !== 'null'));
  }, [data]);
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });

  // console.log('From CompetentProfessionalList: ', data)

  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(CompetentProfessionalListRow, {
      companyId: companyId,
      rowData: currentData,
      key: currentData.id,
      data: data,
      setData: setData,
      tableHeadings: tableHeadings,
      showFileColumns: showFileColumns,
      selectedProjectId: selectedProjectId,
      forNewProjectCreation: forNewProjectCreation,
      removeNewProjectCompetentProfessional: removeNewProjectCompetentProfessional,
      addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
      updateNewProjectCompetentProfessionals: updateNewProjectCompetentProfessionals
    });
  });
  const emptyRows = emptyList.map(emptyRow => {
    return /*#__PURE__*/React.createElement(CompetentProfessionalListRow, {
      companyId: companyId,
      key: 'createRowList' + emptyRow.emptyRowId,
      emptyRowId: emptyRow.emptyRowId,
      data: data,
      setData: setData,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyRow,
      tableHeadings: tableHeadings,
      showFileColumns: showFileColumns,
      selectedProjectId: selectedProjectId,
      forNewProjectCreation: forNewProjectCreation,
      removeNewProjectCompetentProfessional: removeNewProjectCompetentProfessional,
      addCompetentProfessionalToNewProject: addCompetentProfessionalToNewProject,
      updateNewProjectCompetentProfessionals: updateNewProjectCompetentProfessionals
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, duplicates.length > 0 && /*#__PURE__*/React.createElement(Alert, {
    variant: "danger"
  }, "Be careful you have created competent professionals with the same e-mail address ", duplicates.join(', ')), /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, !searchQuery.length && emptyRows)));
};
export default CompetentProfessionalList;